/**
 * Wrap a pageview capture so it fires once per URL: a repeat of the URL last
 * captured is not a new view.
 *
 * The router's `onResolved` — what the PostHog provider hangs pageviews on —
 * also fires when nothing navigated (every `updateMatch`, hover preloads
 * included, settles a transition). Without this, the current page was logged
 * again each time the mouse crossed a sidebar link.
 */
export function onePageviewPerUrl(
  capture: (href: string) => void
): (href: string) => void {
  let lastHref: string | undefined;
  return (href) => {
    if (href === lastHref) return;
    lastHref = href;
    capture(href);
  };
}
